import Locale, { LocaleId } from "../../../core/src/utils/Locale";
import MessagePopup from "../../../core/src/ui/popups/MessagePopup";
import ErrorPopup from "../../../core/src/ui/popups/ErrorPopup";
import ErrorModel from "../../../core/src/model/ErrorModel";
export default class InsufficientPopup extends MessagePopup {

    public show(callback) {
        super.show(callback);
        
        this.setText(Locale.getString(LocaleId.insufficient_funds));
        this.setTitle(Locale.getString(LocaleId.insufficient_funds_title));
    }

    public hide(): void {
        super.hide();
        ErrorModel.errorCode = -1;
    }
}